import { EVENT, SCREEN } from '../../Constants/AnalyticsConstants';
import { fbLogEvent } from '../../Helpers/FirebaseHelper';
import APIClient from '../../Services/AxiosClient';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';

export const updateFeedback = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.GLOBAL?.FEEDBACK,
      method: 'post',
      data: queryPayload?.payload,
    });
    queryPayload?.callback && queryPayload?.callback(response?.message);
    return response;
  } catch (err) {
    fbLogEvent(EVENT.UE_FEEDBACK_FAILURE, {
      screen: SCREEN.FEEDBACK_MODAL,
      lead: SCREEN.FEEDBACK_MODAL,
    });
    return null;
  }
};
